module.exports = __webpack_public_path__ + "static/media/publish-videos-images-tablet-en.92703afe.webp";